import { render } from "./HeadlineSelection.vue?vue&type=template&id=4da18554&scoped=true&ts=true"
import script from "./HeadlineSelection.vue?vue&type=script&lang=ts"
export * from "./HeadlineSelection.vue?vue&type=script&lang=ts"

import "./HeadlineSelection.vue?vue&type=style&index=0&id=4da18554&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da18554"]])

export default __exports__